module.exports = __webpack_public_path__ + "assets/img/7_1550_big.14ff9e77.jpg";